{
    "update_date": "Update of {{date}}",
    "new_delivery": "New delivery - {{date}}",
    "editions": {
        "sp2627": {
            "title": "Your monetic portal is evolving 🚀",
            "intro": "Discover a portal with a modern design and a redesigned ergonomics for a smoother and more intuitive experience.",
            "list_title": "<1>The main evolutions :</1>",
            "list": {
                "item1": "A <1>modern design</1> and a more intuitive navigation",
                "item2": "A <1>reorganized menu</1> with better structured rubrics and sub-rubrics",
                "item3": "Key actions directly accessible to limit manipulations",
                "item4": "More readable and enriched tables (copy-paste data, non-truncated information)",
                "item5": "An <1>optimized experience</1> on computer and mobile",
                "item6": "<1>Overall performance improvements</1>",
                "item7": "A <1>technically modernized</1> and more robust platform"
            },
            "conclusion": "This new version is already available. In order to allow a gradual transition, the old version will remain accessible for a few weeks."
        },
        "sp2603": {
            "title": "Faster display and sorting fix",
            "item1": "<1>Discounts screen: reduced loading times</1> for smoother navigation. This optimization work is part of a <2>broader performance initiative.</2>",
            "item2": "<1>Terminals screen</1>: sorting fixed on the <2>« Connected on »</2> field."
        },
        "sp2525": {
            "title": "Improved display of results in portal tables",
            "body": "Following the release, the default display of results in all portal tables has been <1>changed from 20 to 100 rows per page.</1> This update lets you see more information at a glance and work more efficiently when reviewing and analysing your data."
        },
        "sp2531": {
            "title": "Scheduled discount exports in the Merchant Portal",
            "intro": "With this feature you can now <1>schedule automatic sending of discount data</1> at the frequency that suits you best.",
            "howTitle": "How do I enable scheduled discount exports?",
            "step1": "Log in to your Merchant Portal.",
            "step2": "Open the <1>Discounts</1> menu.",
            "step3": "Click the <1>page actions</1> button, then <2>Export</2>.",
            "step4": "Select the <1>Scheduled export</1> option.",
            "step5Intro": "Choose the desired frequency:",
            "freq_daily": "<1>Daily</1>: you will receive the previous day’s data.",
            "freq_weekly": "<1>Weekly</1>: you will receive the past week’s data.",
            "freq_monthly": "<1>Monthly</1>: you will receive the past month’s data.",
            "important": "Important",
            "imp1": "For performance reasons, only <1>one export per frequency</1> can be scheduled <2>per merchant account</2>.",
            "imp2": "This feature is only available to users with the <1>permission: « Manage discount exports »</1>.",
            "imp3": "Once scheduled, <1>the automatic export will remain available for 1 year.</1>"
        },
        "sp2537": {
            "title": "Pagination on the Discounts screen",
            "p1": "Result pagination has been revised for <1>faster display of results</1>.",
            "changes": "What changes:",
            "li1": "Up to 10 pages of results visible; additional pages appear gradually as you navigate.",
            "li2": "You can still navigate with Previous and Next, or by entering a page number directly.",
            "li3": "The total number of results is no longer shown."
        },
        "sp2540": {
            "title": "Export of user history",
            "body": "User history export is now available from the page action button, then the « export users » button."
        },
        "sp2549": {
            "section_1": {
                "title": "New Bouygues Telecom operator",
                "p1": "A new operator is now available for your SIM cards: <1>Bouygues Telecom!</1> ",
                "intro": "With this offer:",
                "li1": "Plans up to 1 GB, <1>100% suited to Android terminals</1>, for a smooth, high-performing payment experience ",
                "li2": "<1>Automatic addition of new SIM cards</1> to the portal after an order",
                "li3": "The ability to <1>replace a SIM card</1> that is obsolete or lost while keeping the original data (associated configuration retained)",
                "p2": "All usual SIM features are also available with this operator: card management, consumption tracking and alert configuration, for full control of your SIM fleet."
            },
            "section_2": {
                "title": "Scheduled transaction exports",
                "p1": "After releasing <1>scheduled discount exports</1> on the Discounts screen, we are now completing the feature with <2>scheduled transaction exports</2>.",
                "p2": "This new option <1>lets you schedule automatic sending of transaction data</1> at the frequency you prefer.",
                "how": "How do I enable scheduled transaction exports?",
                "ol1": "Log in to your Merchant Portal and open the <1>Transactions</1> menu.",
                "ol2": "Click the page actions button, then <1>Export</1>.",
                "ol3": "Select <1>Scheduled export</1>, then <2>choose the frequency</2> you want:",
                "nested1": "<1>Daily</1>: previous day’s data.",
                "nested2": "<1>Weekly</1>: past week’s data.",
                "nested3": "<1>Monthly</1>: past month’s data.",
                "important": "Important",
                "ul1": "Once scheduled, <1>the automatic export runs for one year.</1>",
                "ul2": "<1>For this first version, only one export</1> can be scheduled <2>per merchant account</2>.",
                "ul3": "This feature is only available to users with the <1>permission: « Manage transaction exports »</1>."
            }
        }
    }
}